module.exports = __webpack_public_path__ + "img/cart.6e5d4809.svg";